module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/configuracion/configuracion.component.scss
// module id = ./src/app/components/configuracion/configuracion.component.scss
// module chunks = main